/**
 * Mapeo de iconos tim-icons a FontAwesome
 * Para mantener compatibilidad y evitar problemas de carga
 */
export const iconMapper = {
  // Dashboard
  'tim-icons icon-chart-pie-36': 'fas fa-chart-pie',
  
  // Configuración
  'tim-icons icon-settings-gear-63': 'fas fa-cog',
  'tim-icons icon-bank': 'fas fa-building',
  'tim-icons icon-shop': 'fas fa-store',
  
  // Productos
  'tim-icons icon-bag': 'fas fa-shopping-bag',
  'tim-icons icon-box-2': 'fas fa-box',
  'tim-icons icon-tag': 'fas fa-tag',
  
  // Inventario
  'tim-icons icon-archive-2': 'fas fa-archive',
  
  // Clientes
  'tim-icons icon-single-02': 'fas fa-user',
  
  // Ventas
  'tim-icons icon-cart': 'fas fa-shopping-cart',
  
  // Facturación
  'tim-icons icon-paper': 'fas fa-file-invoice',
  
  // Administración
  'tim-icons icon-settings': 'fas fa-cogs',
  'tim-icons icon-badge': 'fas fa-id-badge',
  'tim-icons icon-key-25': 'fas fa-key',
  
  // Reportes
  'tim-icons icon-chart-bar-32': 'fas fa-chart-bar',
  
  // Auditoría
  'tim-icons icon-notes': 'fas fa-clipboard-list',
  
  // Acciones comunes
  'tim-icons icon-simple-add': 'fas fa-plus',
  'tim-icons icon-simple-remove': 'fas fa-times',
  'tim-icons icon-pencil': 'fas fa-pencil-alt',
  'tim-icons icon-zoom-split': 'fas fa-search',
  'tim-icons icon-cloud-download-93': 'fas fa-download',
  'tim-icons icon-refresh-02': 'fas fa-sync-alt',
  'tim-icons icon-spaceship': 'fas fa-rocket',
  'tim-icons icon-bullet-list-67': 'fas fa-list',
};

/**
 * Convierte un icono tim-icons a FontAwesome
 * @param {string} timIcon - Clase del icono tim-icons
 * @returns {string} Clase del icono FontAwesome
 */
export const getIcon = (timIcon) => {
  if (!timIcon) return 'fas fa-circle';
  
  // Si ya es un icono FontAwesome, devolverlo tal cual
  if (timIcon.startsWith('fas ') || timIcon.startsWith('far ') || timIcon.startsWith('fab ')) {
    return timIcon;
  }
  
  // Buscar en el mapeo
  return iconMapper[timIcon] || 'fas fa-circle';
};

